import { HttpClient } from './HttpClient';
import { getApiUrl } from './UrlBuilder';

import { Skill } from 'models';

import { UserManager, HALManager } from 'core';

export class SkillsService {
  private httpClient: HttpClient = new HttpClient();

  public async getSkills() {
    const urlRequest = getApiUrl(HALManager.getSkillsUrl(UserManager.userId));

    const response = await this.httpClient.get<Skill[]>(urlRequest);

    return response.object;
  };

  public async addSkill(skill: Skill) {
    const urlRequest = getApiUrl(HALManager.addSkillUrl(UserManager.userId));
    const requestParams = { body: JSON.stringify(skill) };

    const response = await this.httpClient.post<Skill>(urlRequest, requestParams);

    return response.object;
  };

  public async updateSkill(skill: Skill) {
    const urlRequest = getApiUrl(HALManager.updateSkillUrl(UserManager.userId, skill.id));

    const requestParams = { body: JSON.stringify(skill) };

    const response = await this.httpClient.put<Skill>(urlRequest, requestParams);

    return response.object;
  };

  public async deleteSkill(skillId: string) {
    const urlRequest = getApiUrl(HALManager.deleteSkillUrl(UserManager.userId, skillId));

    await this.httpClient.delete(urlRequest);
  };
}

export default new SkillsService();
